/**
 * Format number with a thousand separator dots
 * @param {number|string} value - The value to format
 * @returns {string} Formatted number with a thousand separator dots
 * @example
 * formatNumber(1000) => "1.000"
 * formatNumber(1000000) => "1.000.000"
 */
export function formatNumber(value) {
  return value
  // if (!value && value !== 0) return '0';
  // const num = typeof value === 'string'
  //   ? parseFloat(value.replace(/\./g, '').replace(/,/g, ' ').replace(/\s/g, ''))
  //   : value;
  // if (isNaN(num)) return '0';
  // // Auto format with thousand separator dots
  // return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}
